<script>
import Modal from "./Modal";

export default {
  props: ["loginUrl", "forgetUrl", "default", "intended"],

  mixins: [Modal],

  data() {
    return {
      show: "login",
      showPassword: false,
      sent: false,
      email: null,
      password: null,
      redirectTo: null,
    };
  },

  methods: {
    showLogin() {
      this.show = "login";

      this.$nextTick(() => {
        this.$refs.email.focus();
      });
    },

    submitForgetForm($event, originalOnSubmit) {
      var promise = originalOnSubmit($event);

      var vm = this;

      promise
        .then(function (result) {
          vm.sent = true;
        })
        .catch(() => {});
    },

    showForget() {
      this.show = "forget";
    },
  },

  mounted: function () {
    var vm = this;

    this.$on("modal-opened", function (data) {
      this.email = this.password = null;
      this.sent = false;
      this.redirectTo = null;
      this.showLogin();
    });

    this.$root.$on("open-login-modal", function (data) {
      vm.open();

      if (data && data.url) {
        vm.redirectTo = data.url;
      }
    });

    if (this.default) {
      vm.open();
    }

    if (this.intended) {
      this.redirectTo = this.intended;
    }
  },
};
</script>
